import { Alert, Container } from '@mui/material';
import { PageOuterContainer } from '../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../presentation-components/display-elements-components/page-heading';
import { OrganisationSsoSettings } from '../../presentation-components/settings-components/organisation-sso-settings';

// Partner Settings > Security > Single sign-on: configures SSO for the partner's
// own organisation only. Client SSO is deliberately not managed here.
export const PartnerSsoPage = () => {
  return (
    <PageOuterContainer>
      <PageHeading title="Single sign-on" hasTabs={false} />
      <Container maxWidth={false} sx={{ px: 0 }}>
        <Alert severity="info" sx={{ mb: 3, maxWidth: 560 }}>
          This configures single sign-on for your own organisation. To enable single sign-on for a client, sign in to that client&apos;s account and set it up from there.
        </Alert>
        <OrganisationSsoSettings returnTo="/partner-settings/security/single-sign-on" />
      </Container>
    </PageOuterContainer>
  );
};
